module.exports = __webpack_public_path__ + "img/hero.4a00e1e1.svg";